{
    "ExcludeheldtimeLabel": "Haltezeit ausschließen:",
    "TalkTime_SectionHeader": "Sprechzeit",
    "TalkTime_SectionPara": "Sie können wählen, ob die gesprächszeitbezogenen Statistiken die gehaltene Zeit des Anrufs aus der Berechnungslogik ausschließen sollen.",
    "NAME": "TalkTime"
}